import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

interface Goal {
  id: number;
  title: string;
  data: Record<string, any>;
  created_at: string;
  updated_at: string;
}

const GoalView: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const [goal, setGoal] = useState<Goal | null>(null);

  useEffect(() => {
    fetchGoal();
  }, [id]);

  const fetchGoal = async () => {
    try {
      const response = await fetch(`/api/goals/${id}`);
      const data = await response.json();
      setGoal(data);
    } catch (error) {
      console.error('Error fetching goal:', error);
    }
  };

  if (!goal) {
    return <div className="p-4">Loading...</div>;
  }

  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold mb-4">{goal.title}</h1>
      <p className="text-sm text-gray-500 mb-4">Created: {new Date(goal.created_at).toLocaleDateString()}</p>
      <div className="prose max-w-none">{/* Add your goal content here */}</div>
    </div>
  );
};

export default GoalView;
